module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"notice_detail":"查看公告詳情"}}')
  delete Component.options._Ctor
}
